module.exports = require("./ff-Latn-NE.js");